module.exports = __webpack_public_path__ + "static/media/footer_instagram.c3fb5664.svg";